import { render, staticRenderFns } from "./network_err.vue?vue&type=template&id=6716456a&scoped=true&"
import script from "./network_err.vue?vue&type=script&lang=js&"
export * from "./network_err.vue?vue&type=script&lang=js&"
import style0 from "./network_err.vue?vue&type=style&index=0&id=6716456a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6716456a",
  null
  
)

export default component.exports